import { toastEventDispatch } from '@hotmart/space-lib-events/dist/toast'
import { ToastPosition, ToastType } from '@hotmart/space-lib-events/dist/toast/enum'
import i18n from 'src/i18n'
import { CommunitiesEndpoints } from 'src/client/constants'
import { queryClient } from 'src/config/request'
import { useParams } from 'react-router-dom'
import { PublicationEndpoints } from 'src/client/publication/constants'
import useEditPostModalMutation from '../useEditPostModalMutation/useEditPostModalMutation'
import { UseEditPostSubmitProps } from './useEditPostSubmit.types'

const useEditPostSubmit = () => {
  const { mutate: editPostMutation, isLoading } = useEditPostModalMutation()
  const { membership, idCommunity, idPost } = useParams()

  const invalidateQueries = (isScheduledPosts: boolean, isPinnedPost: boolean) => {
    const queryKey = isScheduledPosts ? 'getScheduledPosts' : 'getPosts'
    queryClient.invalidateQueries([queryKey])

    isPinnedPost && queryClient.invalidateQueries(['getPinnedPosts'])

    queryClient.invalidateQueries({
      queryKey: [CommunitiesEndpoints.getCommunity(Number(idCommunity))]
    })

    queryClient.invalidateQueries({
      queryKey: [CommunitiesEndpoints.getCommunityBySlug(membership as string)]
    })

    idPost &&
      queryClient.invalidateQueries({
        queryKey: [PublicationEndpoints.getPost(Number(idPost))]
      })
  }

  const handleSubmit = ({
    title,
    description,
    postId,
    isPinnedPost,
    onClose,
    isScheduledPosts
  }: UseEditPostSubmitProps) => {
    editPostMutation(
      {
        title,
        description,
        postId
      },
      {
        onSuccess: () => {
          onClose()
          toastEventDispatch({
            type: ToastType.SUCCESS,
            message: i18n.t('edit_post.success_toast'),
            position: ToastPosition.BOTTOM_RIGHT
          })

          invalidateQueries(isScheduledPosts, isPinnedPost)
        },
        onError: () => {
          toastEventDispatch({
            type: ToastType.DANGER,
            message: i18n.t('edit_post.error_toast'),
            position: ToastPosition.BOTTOM_RIGHT
          })
        }
      }
    )
  }

  return { handleSubmit, isLoading }
}

export default useEditPostSubmit
